import { useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

function ImageSlider({ isOpen, onClose, total, images = [], baseUrl,startIndex = 0 }) {
   const [currentIndex, setCurrentIndex] = useState(startIndex);
   
    
  if (!isOpen) return null; // hide if modal not open

  return (
    <div className="image-modal" id="details_pagess">
      <div className="image-count">
          {currentIndex + 1} / {total}
        </div>
      <div className="modal-content">
        <button className="close-btn" onClick={onClose}>
          ✖
        </button>

          
        <Swiper
          modules={[Navigation]}
          navigation
        //autoplay={{ delay: 2500 }}
         
          slidesPerView={1}
           onSlideChange={(swiper) => setCurrentIndex(swiper.activeIndex)}
          initialSlide={startIndex}
        >
          {images.map((img, index) => (
            <SwiperSlide key={index}>
              <img
                src={`${baseUrl}${img.image}`}
                alt={`slide-${index}`}
                className="modal-image"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default ImageSlider;
